import { composeGuards, redirectIfUnauthorized } from '@/app/shared/utils/router-guards/auth';
import { redirectWithMainEventScope } from '@/app/shared/utils/router-guards/mainEvent';

const BASE_PATH = '/seating';

export const seatingGuestOperationsRoutes = [
    {
        path: `${BASE_PATH}/main-events`,
        name: 'SeatingGuestOperationsMainEventList',
        component: () =>
            import('@/app/modules/seating/guestOperations/MainEventsList/MainEventsList.vue'),
        props: true,
        beforeEnter: composeGuards(
            redirectIfUnauthorized(
                (permissions) => permissions.seating.guestOperations.mainEventList
            ),
            redirectWithMainEventScope((mainEventId) => ({
                name: 'SeatingGuestOperationsEventList',
                params: { mainEventId },
            }))
        ),
    },
    {
        path: `${BASE_PATH}/main-events/full-list`,
        name: 'SeatingGuestOperationsMainEventFullList',
        component: () =>
            import(
                '@/app/modules/seating/guestOperations/MainEventsFullList/MainEventsFullList.vue'
            ),
        props: true,
        beforeEnter: redirectIfUnauthorized(
            (permissions) => permissions.seating.guestOperations.mainEventList
        ),
    },
    {
        path: `${BASE_PATH}/main-events/:mainEventId/events`,
        name: 'SeatingGuestOperationsEventList',
        component: () => import('@/app/modules/seating/guestOperations/EventsList/EventsList.vue'),
        props: true,
        beforeEnter: redirectIfUnauthorized(
            (permissions) => permissions.seating.guestOperations.eventList
        ),
    },
    {
        name: 'SeatingGuestOperationsPicker',
        path: `${BASE_PATH}/picker/:mainEventId/:eventId`,
        component: () => import('@/app/modules/seating/guestOperations/Picker/PickerView.vue'),
        props: true,
        beforeEnter: redirectIfUnauthorized(
            (permissions) => permissions.seating.guestOperations.picker
        ),
    },
    {
        name: 'SeatingGuestOperationsDeliveryStatuses',
        path: `${BASE_PATH}/delivery-statuses/:mainEventId/:eventId`,
        component: () =>
            import('@/app/modules/seating/guestOperations/DeliveryStatuses/DeliveryStatuses.vue'),
        props: true,
        beforeEnter: redirectIfUnauthorized((permissions, user, routeParams) =>
            permissions.seating.guestOperations.deliveryStatuses(routeParams.mainEventId)
        ),
    },
    {
        name: 'SeatingGuestOperationsMatchLogs',
        path: `${BASE_PATH}/match-logs/:mainEventId/:eventId`,
        component: () => import('@/app/modules/seating/guestOperations/MatchLogs/MatchLogs'),
        props: true,
        beforeEnter: redirectIfUnauthorized(
            (permissions) => permissions.seating.guestOperations.matchLogs
        ),
    },
];
